import { createRegulatoryFlowCompareSnapshot } from './regulatoryDiagramDomainState';

const hasFlowChanged = async (prevFlow, newFlow) => {
    const filteredPrevFlow = createRegulatoryFlowCompareSnapshot(prevFlow);
    const filteredNewFlow = createRegulatoryFlowCompareSnapshot(newFlow);

    const prevNodesSerialized = JSON.stringify(filteredPrevFlow.nodes);
    const newNodesSerialized = JSON.stringify(filteredNewFlow.nodes);
    const prevEdgesSerialized = JSON.stringify(filteredPrevFlow.edges);
    const newEdgesSerialized = JSON.stringify(filteredNewFlow.edges);

    return prevNodesSerialized !== newNodesSerialized || prevEdgesSerialized !== newEdgesSerialized;
};

export default hasFlowChanged